var disqus_comments = {
  get_count: function () {
    // Disqus fix for load comments number after ajax response
    var nodes = document.getElementsByTagName('span');
    for (var i = 0, url; i < nodes.length; i++) {
      if (nodes[i].className.indexOf('dsq-postid') != -1 && nodes[i].parentNode.tagName == 'A') {
        nodes[i].parentNode.setAttribute('data-disqus-identifier', nodes[i].getAttribute('data-dsqidentifier'));
        url = nodes[i].parentNode.href.split('#', 1);
        if (url.length == 1) {
          url = url[0];
        } else {
          url = url[1];
        }
        nodes[i].parentNode.href = url + '#disqus_thread';
      }
    }

    DISQUSWIDGETS.getCount();
  }
};

var mutationObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    jQuery('.show-comments--button span').html(mutation.addedNodes[0].data);
    mutationObserver.disconnect();
  });
});

if (typeof document.querySelectorAll('.single .b-article-header-author .meta-comment')[0] != 'undefined') {
  mutationObserver.observe(document.querySelectorAll('.single .b-article-header-author .meta-comment')[0], {
    subtree: true,
    childList: true,
  });
}
